import { useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { capitalize } from '@/utils/strings'
import { Spinner } from '@/components/ui'
import { SingleLineAddressOnListing } from '@/components/Address'

import { setCurrentBien, fetchBien, getHasMandatOfTypeFunc } from '@/features/biens/biensSlice'
import BienContext from '@/features/biens/BienContext'
import Location from './show/Location'
import Vente from './show/Vente'
import LegalDocumentFiles from '../common/LegalDocumentFiles'
import Visites from './show/Visites'
import Entretiens from './show/Entretiens'
import Interventions from './show/Interventions'
import Activities from '../common/Activities'
import Assurance from './show/Assurance'

// Composant pour le titre
const BienTitle = () => {
  const { bien } = useContext(BienContext)

  return (
    <div className="bien-title flex flex-col md:flex-row justify-between mb-2 text-sm md:text-md">
      <div className="font-bold flex flex-col items-center md:items-start gap-3">
        <h2 className="flex flex-col md:flex-row text-xl md:text-2xl">
          <p>
            <span className="mr-2">{capitalize(bien.type_bien)}</span>
            <span className="mr-2">{bien.type_bien === 'appartement' ? ` n° ${bien.numero_appartement}` : ' '}</span>
          </p>
          <div className='flex justify-center'>
            <span className="hidden md:inline mx-2">-</span>
            <SingleLineAddressOnListing data={bien} withCodePostal={false} withApptNumber={false} />
          </div>
        </h2>
      </div>
    </div>
  )
}

const BienShow = ({bien}) => {
  const dispatch = useDispatch()
  const currentBien = useSelector((state) => state.biens.current)
  const loading = useSelector((state) => state.biens.loadingStatus.fetchItem)

  // Exécuté uniquement au premier montage du composant
  useEffect(() => {
    dispatch(setCurrentBien(bien));
    dispatch(fetchBien(bien.id))
  }, [bien.id]) 

  const hasMandatOfType = getHasMandatOfTypeFunc(currentBien)

  const MenuButtons = () => (
    <>
      { hasMandatOfType("vente") && (
        <a className="btn" href="#vente">
          <span className="dock-label">La vente</span>
        </a>
      )}
      { hasMandatOfType("location") && bien.type_bien !== "immeuble" && (
        <a className="btn" href="#location">
          <span className="dock-label">La location</span>
        </a>
      )}
      { bien.type_bien !== "immeuble" &&
        <a className="btn" href="#legal_files">
          <span className="dock-label">Document légaux</span>
        </a>
      }
      { hasMandatOfType("vente") && (
        <a className="btn" href="#visites">
          <span className="dock-label">Visites</span>
        </a>
      )}
      <a className="btn" href="#entretiens">
        <span className="dock-label">Entretiens</span>
      </a>
      <a className="btn" href="#interventions">
        <span className="dock-label">Interventions</span>
      </a>
      <a className="btn" href="#activities">
        <span className="dock-label">Activités</span>
      </a>
    </>
  )

  return (
    <BienContext.Provider value={{
      bien: currentBien || bien, 
      loading
    }}>
      <div className="show-container">
        <div className='flex flex-col lg:flex-row lg:items-center'>
          <BienTitle />

          {/* <div className="menu hidden lg:block lg:menu-horizontal m-auto space-x-2 space-y-2 mb-2">
            <MenuButtons/>
          </div> */}
        </div>

        <div className="content-container space-y-4">
          { loading && <div className='overflow-hidden mb-4'>
              <h3 className="text-md font-semibold mb-2">
                Informations générales
              </h3>
              <div className="w-full bg-primary-100 p-4 rounded-none"> 
                <Spinner />
              </div>
            </div>
          }
          { hasMandatOfType("vente") && <div id="vente"><Vente /></div> }
          { bien.type_bien !== "immeuble" && hasMandatOfType("location") && 
              <div id="location"><Location /></div>
          }
          { bien.type_bien === "immeuble" && (!bien.mandats || bien.mandats?.length == 0 || hasMandatOfType("location") ) &&
              <div className="flex flex-col h-full">
                <h3 className="text-md font-semibold mb-2">
                  Informations sur votre immeuble
                </h3>
                <div className={`w-full h-full bg-primary-100 p-4 rounded-none`}> 
                  { loading && <Spinner /> }
                  { !loading && <Assurance 
                    assurance={bien.assurance_proprietaire} 
                    date_dernier_releve={bien.assurance_proprietaire_date_dernier_releve } 
                    />
                  }
                </div>
              </div>
          }
          <div id="legal_files"><LegalDocumentFiles /></div>
          { hasMandatOfType("vente") && <div id="visites"><Visites /></div> }
          <div id="entretiens"><Entretiens /></div>
          <div id="interventions"><Interventions /></div>
          <div id="activities"><Activities /></div>
        </div>
      </div>
      <div className="dock overflow-x-auto space-x-2 lg:hidden">
        <MenuButtons /> 
      </div>
    </BienContext.Provider> 
  )
}

export default BienShow
